export default __webpack_public_path__ + "static/media/hero-bg-waves.385274d3.svg";